__turbopack_context__.v({
  "ellipsis": "CqZeEG_ellipsis",
  "pageButton": "CqZeEG_pageButton",
  "pageButtonLabel": "CqZeEG_pageButtonLabel",
  "pageButtonSelected": "CqZeEG_pageButtonSelected",
  "paginationWrapper": "CqZeEG_paginationWrapper",
  "root": "CqZeEG_root",
});
